import Joi from 'joi';

/**
 * Schema for new record validation.
 */
export const createVehicleColorSchema = () =>
	Joi.object({})
		// Ignore extra fields
		.unknown();
